import type { IProfile } from '@rpgc-ai/shared-interfaces/interfaces/profile.interface';

/**
 * Состояние хранилища профиля
 */
export interface ProfileState {
  profile: IProfile;
  isLoading: boolean;
  error: string | null;
}

/**
 * Начальное значение для profile
 */
export const initialProfile: IProfile = {
  id: null,
  name: null,
  email: null,
  boostyEmail: undefined,
  defaultPersonaId: null,
  defaultPersonaSlug: null,
  nsfwFilter: true,
  hasAds: false,
  isAdmin: false,
  isAdultConfirmed: true,
  isTermsAccepted: true,
  plan: null,
  planInfo: null,
  theme: null,
  emailVerified: false,
  sentAt: null,
  slug: null,
  connectedAccounts: null,
  registrationDate: null,
  imageGenerationLimits: {
    chat: {
      dailyFreeLimit: null,
      dailyFreeRemaining: null,
      dailyFreeUsed: 0,
      estimatedCostTokens: 0,
      isFree: true,
    },
    characterBackground: {
      dailyFreeLimit: null,
      dailyFreeRemaining: null,
      dailyFreeUsed: 0,
      estimatedCostTokens: 0,
      isFree: true,
    },
  },
  balance: null,
  subscriptionExpiresAt: null,
};

/**
 * Полное состояние стора включая profile
 */
export const profileState = {
  profile: initialProfile,
  isLoading: false,
  error: null as string | null,
};

/**
 * Начальное состояние хранилища профиля (для обратной совместимости)
 */
export const initialProfileState: ProfileState = {
  profile: initialProfile,
  isLoading: false,
  error: null,
};
